import { colors } from 'app-v2/design-systems/theme'
import { FastFoodBag } from 'app/assets/icons'
import { ButtonMedium, media, style } from 'app/assets/styles'
import { FeatureToggle } from 'app/common/feature-toggle'
import { CcCartCheck } from 'app/ecommerce/click-and-collect/cart-check'
import _ from 'lodash'
import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import Modal from 'react-modal'
import { useDispatch } from 'react-redux'
import { colors as oldColors } from 'shared/assets/styles'
import { eventMetadata, eventsDefinitions } from 'shared/store/metadata'
import type { CacOrder } from 'shared/types'
import { featureCodes } from 'shared/utils'
import styled from 'styled-components'
import { ReuseOrderModal } from './ReuseOrderModal'

const { yellow } = oldColors
const { classicModalMobileStyle, classicModalStyle } = style

type Props = {
    order: CacOrder,
    mobile?: boolean
}

export const ReuseOrder = ({ mobile, order }: Props) => {
    const { pickUpType, restaurant } = order
    const [showModal, setShowModal] = useState(false)
    const dispatch = useDispatch()

    const onDeliverySet = () => {
        setShowModal(true)
        dispatch(
            eventMetadata({
                ...eventsDefinitions.GA4_COMMAND_REUSE,
                page_template: window.location.pathname.includes('kingdom')
                    ? 'Kingdom'
                    : 'Click & Collect',
                transaction_id: order.id,
                value: order.finalPrice
            })
        )
    }

    return (
        <div>
            <FeatureToggle feature={featureCodes.CLICK_AND_COLLECT}>
                <CcCartCheck
                    restaurant={restaurant}
                    pickUpType={pickUpType}
                    onDeliverySet={onDeliverySet}>
                    <StyledButtonMedium
                        background={yellow}
                        color="white"
                        border={yellow}
                        mobile={mobile}>
                        <StyledFastFoodBagIconContainer>
                            <StyledFastFoodBag
                                bagColor="white"
                                arrowColor={yellow}
                                size={20}
                            />
                            <FormattedMessage id="clickandcollect.catalog.trigger.order.again.new" />
                        </StyledFastFoodBagIconContainer>
                    </StyledButtonMedium>
                </CcCartCheck>
            </FeatureToggle>
            <Modal
                isOpen={showModal}
                ariaHideApp={false}
                shouldCloseOnOverlayClick
                style={getModalStyle(mobile)}>
                <ReuseOrderModal
                    handleClose={() => setShowModal(false)}
                    order={order}
                />
            </Modal>
        </div>
    )
}

const getModalStyle = (mobile?: boolean) => {
    const basicStyle = _.cloneDeep(
        mobile ? classicModalMobileStyle : classicModalStyle
    )
    basicStyle.content.background = colors.lightMayo
    return basicStyle
}

const StyledFastFoodBagIconContainer = styled.div`
    display: flex;
    justify-content: center;
`

const StyledFastFoodBag = styled(FastFoodBag)`
    margin-right: 8px;
`

const StyledButtonMedium = styled(ButtonMedium)`
    margin-bottom: 20px;
    width: 100%;
    ${props => props.mobile && `margin-top: 14px;`}
    ${media.medium`
        margin-left: 20px;
    `};
`
